import { render, staticRenderFns } from "./weak-password-alert.vue?vue&type=template&id=126ee48c&scoped=true"
import script from "./weak-password-alert.vue?vue&type=script&lang=js"
export * from "./weak-password-alert.vue?vue&type=script&lang=js"
import style0 from "./weak-password-alert.vue?vue&type=style&index=0&id=126ee48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ee48c",
  null
  
)

export default component.exports